import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { TonConnectUIProvider } from "@tonconnect/ui-react";
import "./polyfills";

const manifestUrl =
    "https://cryptolotto777.com/tonconnect-manifest.json";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <TonConnectUIProvider manifestUrl={manifestUrl}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </TonConnectUIProvider>
);

reportWebVitals();